import type React from 'react'

/**
 * PSV-352 — contorna um bug do `UploadFile` do `@pnld/components-web`.
 *
 * Ao remover o arquivo, o componente limpa o input e dispara nele um `change`
 * sintético. O `onChange` dele então lê `Array.from(target.files)[0].size` para
 * comparar com `maxSize` — e `files` acabou de ficar vazio:
 *
 *     TypeError: can't access property "size", e is undefined
 *
 * Não dá para passar props ao input interno, então a interceptação é na fase de
 * captura de um ancestral, onde o handler roda antes do handler do input.
 * Anexar e trocar arquivo passam direto: trazem `files.length > 0`.
 *
 * Remover quando a lib guardar `files[0]` antes de ler `.size`.
 */
export const blockEmptyFileChange = (event: React.SyntheticEvent): void => {
  const target = event.target as HTMLInputElement | null

  if (target?.type === 'file' && target.files?.length === 0) {
    event.stopPropagation()
  }
}

export default blockEmptyFileChange
